import { Sort } from '@types'
import { random, times } from 'lodash'

export const generateRandomKey = () =>
  times(5, () => random(35).toString(36)).join('')

export const formatSortParams = (params?: Sort[]) => {
  const result = params
    ?.filter(item => !!item.field)
    .map(({ field, sortDirection }, index) => ({
      field,
      sortDirection,
      index,
    }))
  if (!result?.length) return
  return result
}
